module.exports = __webpack_public_path__ + "img/francoeur_6_1.075a785b.jpg";